import { useMemo } from 'react';
import type { ParsedProductPreview } from 'src/types/marketplace';
import { Link } from 'src/uikit/Link';

import {
  formatDisplayName,
  getMarketplaceProductUrl,
} from '../../utils/marketplace/paths';
import s from './MarketplaceCard.module.scss';

export function MarketplaceCard({
  displayName,
  slug,
  logoLink,
  previewText,
}: ParsedProductPreview) {
  const linkToProduct = useMemo(() => getMarketplaceProductUrl(slug), [slug]);
  const transformedDisplayName = useMemo(
    () => formatDisplayName(displayName),
    [displayName],
  );

  return (
    <article data-qa="card" className={s.root}>
      <header>
        <div className={s.cardImageSquare}>
          <img
            src={logoLink}
            alt={displayName}
            data-qa="card-preview-image"
            height={60}
          />
        </div>
      </header>

      <section>
        <h4 className={s.cardTitle}>
          <Link
            data-qa="card-title-link"
            href={linkToProduct}
            analyticsOptions={{
              action: linkToProduct,
              clickZone: 'body',
              clickElement: 'cardclick',
              clickContent: linkToProduct,
              uniqueId: 'marketplace-product-card-click',
              transitionType: 'inside-link',
            }}
          >
            {transformedDisplayName}
          </Link>
        </h4>

        <div data-qa="card-preview-text" className={s.cardDescription}>
          {previewText}
        </div>
      </section>
    </article>
  );
}
